module.exports = __webpack_public_path__ + "static/Logo-02-white-30499ae004072b1c38048439c5c1e8a8.png";